(function () {
	'use strict';

	// If #references is added to the URL, apply the following rules for showing the first accordion item
	const activateFirstAccordion = () => {
		const firstAccordionItem = document.querySelector('.wp-block-aab-accordion-item');
		if (firstAccordionItem) {
			firstAccordionItem.classList.add('aagb__accordion_active');
			const accordionHead = firstAccordionItem.querySelector('.aagb__accordion_head');
			const accordionBody = firstAccordionItem.querySelector('.aagb__accordion_body');
			const accordionIcon = firstAccordionItem.querySelector('.aagb__icon');
			if (accordionHead) {
				accordionHead.classList.add('active');
			}
			if (accordionBody) {
				accordionBody.classList.add('aagb__accordion_body--show');
				accordionBody.style.display = 'block';
			}
			if (accordionIcon) {
				accordionIcon.classList.add('dashicons-arrow-up-alt2');
				accordionIcon.classList.remove('dashicons-arrow-down-alt2');
			}
		}
	};

	// Check on page load
	if (window.location.hash === '#references') {
		activateFirstAccordion();
	}

	// Listen for hash changes (clicking links)
	window.addEventListener('hashchange', () => {
		if (window.location.hash === '#references') {
			activateFirstAccordion();
		}
	});
})();
